<template>
  <div class="nav-footer">
    <footerWeb v-if="!isMobile"></footerWeb>
    <footerMobile v-if="isMobile"></footerMobile>
  </div>
</template>
<script>
import footerWeb from './footer-web.vue'
import footerMobile from './footer-mobile.vue'
export default {
  name: 'nav-footer',
  data() {
    return {
      isMobile: false,
      clientWidth: 0
    }
  },
  components: {
    footerWeb,
    footerMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
